import React from 'react';

import { Tab, Tabs } from '@sumologic/yama-ds-components';

import { hasMessageId } from 'shared/components/internal/SumoRawMessage';

import { ViewType } from './types';

interface RecordDetailsViewTabsProps {
  record: any;
  view: string;
  onChangeView: (view: ViewType) => void;
}

const RecordDetailsViewTabs = ({
  record,
  view,
  onChangeView,
}: RecordDetailsViewTabsProps) => {
  return (
    <Tabs
      value={view}
      sx={{
        flexGrow: 1,
      }}
    >
      <Tab
        onClick={() => onChangeView('overview')}
        label='Overview'
        value='overview'
      />
      <Tab
        onClick={() => onChangeView('fullDetails')}
        label='Full Details'
        value='fullDetails'
      />
      {hasMessageId(record) && (
        <Tab onClick={() => onChangeView('raw')} label='Raw Log' value='raw' />
      )}
    </Tabs>
  );
};

export default RecordDetailsViewTabs;
